import { useTheme } from "@deere/fuel-react";
import React from "react";

const Asterisk = () => {
  const theme = useTheme();
  return (
    <span
      data-testid="asterisk-symbol"
      style={{ color: theme.tokens.FuelColorAlertErrorIcon }}
    >
      {" "}
      *
    </span>
  );
};

export default Asterisk;
